class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;
    this.isMenuBlock = this.classList.contains('footer-block--menu');
    this.isMobile = () => window.matchMedia('(max-width: 480px)').matches;
    this._wasMobile = this.isMobile();

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    // Removed auto-close/auto-open behavior for mobile/desktop switching
    // document.addEventListener('matchSmall', this.close.bind(this));
    // document.addEventListener('unmatchSmall', this.open.bind(this));

    // Set initial state based on viewport
    if (this.isMobile()) {
      if (this.isMenuBlock) {
        this.detailsContainer.removeAttribute('open'); // menu blocks closed by default on mobile
      } else {
        this.detailsContainer.setAttribute('open', true); // non-menu always open
      }
    } else {
      this.detailsContainer.setAttribute('open', true); // open by default on larger screens
    }

    if (this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('empty', true);
    }

    // Keep state in sync on breakpoint changes (<=480px vs >480px)
    this._onResize = () => {
      const nowMobile = this.isMobile();
      if (nowMobile !== this._wasMobile) {
        if (nowMobile) {
          if (this.isMenuBlock) {
            this.detailsContainer.removeAttribute('open');
          } else {
            this.detailsContainer.setAttribute('open', true);
          }
        } else {
          this.detailsContainer.setAttribute('open', true);
        }
        this._wasMobile = nowMobile;
      }
    };
    window.addEventListener('resize', this._onResize, { passive: true });
  }

  onSummaryClick(event) {
    event.preventDefault();
    // Only toggle on mobile and only for menu blocks.
    if (!this.isMobile() || !this.isMenuBlock) return;

    event.target.closest('details').hasAttribute('open') ? this.close() : this.open();
  }

  open() {
    // On mobile, ensure only one menu block is open at a time
    if (this.isMobile() && this.isMenuBlock) {
      document.querySelectorAll('footer-accordion.footer-block--menu details[open]').forEach((openDetails) => {
        if (openDetails !== this.detailsContainer) {
          openDetails.removeAttribute('open');
        }
      });
    }

    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    // Close only on mobile; keep open on larger screens
    if (this.isMobile() && !this.summaryIsEmpty) {
      this.detailsContainer.removeAttribute('open');
    }
  }
}

customElements.define('footer-accordion', FooterAccordion);